import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { parseEntityId } from '../entity'
import { OK } from 'http-status-codes'

class CargaEntranteAutomotorManual {
  static getRemito (numero, exportador) {
    const axios = getAxiosInstance()
    return axios.get(`carga_entrante_automotor_manual_consulta?r=` +
      `{"clave": {"cuit_exportador": ${exportador}, "nro_comprobante_origen": ${numero}}}`)
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static getTodos () {
    const axios = getAxiosInstance()
    const promise = axios.get(`carga_entrante_automotor_manual_consulta?r=` +
      `{}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getCargaEntranteAutomotorConRemito (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`
    const promise = axios.get(`carga_entrante_automotor_manual_entre_fechas?r=${filtro}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado de carga entrante automotor con remito.')
      return data
    })
  }

  // Guarda los datos relacionados a un remito
  static altaCargaConRemito (remitoValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendRemito(remitoValues)
    const promise = axios.post(`carga_entrante_automotor_manual_ingreso`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static updateCargaConRemito (remitoValues) {
    const { numero, exportador } = remitoValues
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdateRemito(remitoValues)
    const promise = axios.put(`carga_entrante_automotor_manual`, { valores: valores, clave: { exportador: parseInt(parseEntityId(exportador)), nro_comprobante_origen: numero } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result)
  }

  static deleteCargaConRemito (numero, cuitExportador) {
    const axios = getAxiosInstance()
    const filtro = `{"clave":{"nro_comprobante_origen": "${numero}", "exportador": "${cuitExportador}"}}`
    const promise = axios.delete(`carga_entrante_automotor_manual_ingreso?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter, lrsAdapter)
      .then((result) => result)
  }

  // Guarda peso bruto para remito
  static altaPesoBrutoRemito (remitoValues) {
    const { numero, exportador, balanzaBruto, balancero, pesoBruto } = remitoValues
    const valores = {
      nroComprobanteOrigen: numero,
      exportador: parseEntityId(exportador),
      balanzaDeBruto: balanzaBruto,
      balanceroDeBruto: balancero,
      pesoBruto: pesoBruto
    }
    const axios = getAxiosInstance()
    const promise = axios.post(`carga_entrante_automotor_manual_con_bruto`, { valores: { ...valores } })
    return promise
      .then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result)
  }

  static adaptToBackendUpdateRemito (remitoValues = {}) {
    const {
      cereal,
      cerealVariedad,
      exportador,
      numero,
      netoOrigen,
      brutoOrigen,
      camion,
      acoplado,
      chofer,
      planta
    } = remitoValues
    return {
      nroComprobanteOrigen: numero,
      exportador: parseInt(parseEntityId(exportador)),
      cereal: cereal,
      cerealVariedad: (cereal !== 'PELLETSC') ? cerealVariedad : null,
      netoOrigen: netoOrigen,
      brutoOrigen: brutoOrigen,
      camion: (camion != null) ? camion.toUpperCase() : null,
      acoplado: (acoplado != null) ? acoplado.toUpperCase() : null,
      chofer: (parseEntityId(chofer) !== null && parseEntityId(chofer) !== '') ? parseEntityId(chofer) : null,
      nombrePlanta: planta
    }
  }

  static adaptToBackendRemito (remitoValues = {}) {
    const {
      numero,
      exportador,
      cereal,
      cerealVariedad,
      netoOrigen,
      brutoOrigen,
      camion,
      acoplado,
      chofer,
      planta
    } = remitoValues
    return {
      nroComprobanteOrigen: numero,
      exportador: parseEntityId(exportador),
      cereal,
      cerealVariedad: cerealVariedad,
      netoOrigen,
      brutoOrigen,
      camion: (camion != null) ? camion.toUpperCase() : null,
      acoplado: (acoplado != null) ? acoplado.toUpperCase() : null,
      chofer: (parseEntityId(chofer) !== null && parseEntityId(chofer) !== '') ? parseEntityId(chofer) : null,
      nombrePlanta: planta
    }
  }
}

export default CargaEntranteAutomotorManual
